import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7e72e34c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tag" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { key: 0 }

import { ref, watch } from 'vue'

    
export default /*#__PURE__*/_defineComponent({
  props: {
        TagList: {
            type: Array,
            required: true
        },
        isShow: {
            type: Boolean,
            required: false,
            default: false
        }
    },
  emits: ['change'],
  setup(__props, { emit }) {

const props = __props

    

    const activeId = ref<string | number>('')

    

    const change = (id: string) => {
        if (activeId.value !== id) {
            activeId.value = id
            emit('change', id)
        }
    }

    watch(() => props.TagList, (data) => {
        let list: any[] = data
        if (list && list.length !== 0) {
            activeId.value = list[0].id
        }
    }, { immediate: true })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.TagList, (item) => {
      return (_openBlock(), _createElementBlock("div", {
        key: item.id,
        class: _normalizeClass({'tag_item': true, 'tagActive': item.id === activeId.value}),
        onClick: ($event: any) => (change(item.id))
      }, [
        _createElementVNode("span", null, _toDisplayString(item.name), 1),
        (__props.isShow && item.num)
          ? (_openBlock(), _createElementBlock("span", _hoisted_3, "(" + _toDisplayString(item.num) + ")", 1))
          : _createCommentVNode("", true)
      ], 10, _hoisted_2))
    }), 128))
  ]))
}
}

})